export const tabsTheme = {
   light: {
      tab: {
         defaultTextColor: 'text-gray-500',
         selectedTextColor: 'text-primary-700',
         disabledTextColor: 'text-gray-300'
      },
      tabsList: {
         borderBottomColor: 'border-gray-300'
      }
   },
   dark: {}
}
